import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {RequestsModelService} from '../../../Models/Rrhh/Requests/requests-model.service';
import {RequestsTypesModelService} from '../../../Models/Rrhh/Requests/requests-types-model.service';

@Injectable({
  providedIn: 'root'
})
export class RequestsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: RequestsModelService,
    public modelTypes: RequestsTypesModelService,
  ) {
    super(injector);
  }

  /**
   * Obtener las solicitudes
   *
   */
  public getRequests(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getSolicitudes', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar nueva solicitud
   *
   */
  public setRequests(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setSolicitud', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      })
    })
  }


  /**
   * Recuperar los tipos de solicitudes de contrato
   *
   */
  public getRequestsTypes(save: boolean = true): Promise<ApiResponse> {
    return new Promise((resolve, reject) => {
      return this.httpCall('contracts_request/types', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.modelTypes.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });
    });
  }

}
